import { render } from "./ResiTable.vue?vue&type=template&id=14c958fc&scoped=true"
import script from "./ResiTable.vue?vue&type=script&lang=js"
export * from "./ResiTable.vue?vue&type=script&lang=js"

import "./ResiTable.vue?vue&type=style&index=0&id=14c958fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14c958fc"]])

export default __exports__